<div id="coordinator-popup add-new" class="coordinator-popup">
    <form class="form" role="form" autocomplete="off" [formGroup]="addDespachosForm">
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>Añadir visitas</h2>
        </div>
        <div class="popoup-content">
            <div class="block-looper-wrapper">
                <div class="block-looper">
                    <div class="form-wrap form-wrap-half">
                        <div mat-dialog-content>
                            <mat-label class="label">Fecha</mat-label>
                            <mat-form-field class="date" floatLabel="always">
                                <input matInput [matDatepicker]="fecha" formControlName="Realizada" (click)="fecha.open()">
                                <mat-datepicker-toggle matSuffix [for]="fecha" ></mat-datepicker-toggle>
                                <mat-datepicker #fecha ></mat-datepicker>
                            </mat-form-field>
                            <mat-error
                            *ngIf="addDespachosForm.get('Realizada').invalid && addDespachosForm.get('Realizada').touched">
                            <span *ngIf="addDespachosForm.get('Realizada').hasError"> La fecha es obligatoria</span>
                            </mat-error>
                            <mat-error *ngIf="dateValid">
                                La fecha no puede ser posterior a hoy
                            </mat-error>
                        </div>
                    </div>
                    <div class="form-wrap full-width">
                        <div mat-dialog-content>
                            <mat-label class="label">Texto</mat-label>
                            <textarea formControlName="Comentarios"></textarea>
                        </div>
                        
                        <mat-error
                            *ngIf="addDespachosForm.get('Comentarios').invalid && addDespachosForm.get('Comentarios').touched">
                            <span *ngIf="addDespachosForm.get('Comentarios').hasError"> El texto es obligatorio</span>
                        </mat-error>
                    </div>
                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button class="keep" (click)=onSave()><span class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" (click)="onClose()"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>